
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire30b8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire30b8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9su8u", function(module, exports) {

$parcel$export(module.exports, "SessionManager", () => $6e2e1af2d90304fb$export$415798a788f40554);
$parcel$export(module.exports, "getRootPath", () => $6e2e1af2d90304fb$export$5413f45d031c7806);
const $6e2e1af2d90304fb$export$415798a788f40554 = {
    getUser () {
        const user = localStorage.getItem('englisho_user');
        return user ? JSON.parse(user) : null;
    },
    loginUser (userData) {
        localStorage.setItem('englisho_user', JSON.stringify(userData));
    },
    logoutUser () {
        localStorage.removeItem('englisho_user');
        window.location.href = $6e2e1af2d90304fb$export$5413f45d031c7806() + 'index.html';
    }
};
function $6e2e1af2d90304fb$export$5413f45d031c7806() {
    const path = window.location.pathname;
    if (path.includes('/pages/features/flashcards/')) return '../../../';
    if (path.includes('/pages/features/quizz/')) return '../../../';
    if (path.includes('/pages/features/')) return '../../';
    if (path.includes('/pages/info/')) return '../../';
    if (path.includes('/pages/auth/')) return '../../';
    if (path.includes('/pages/core/')) return '../../';
    return './';
}

});


var $9su8u = parcelRequire("9su8u");
class $1118bd67751aa98c$var$Navbar extends HTMLElement {
    connectedCallback() {
        const root = (0, $9su8u.getRootPath)();
        const user = (0, $9su8u.SessionManager).getUser();
        let authSection = `
            <a href="${root}pages/auth/sign-in.html" class="nav-link" style="margin-right: 1rem;">Log in</a>
            <a href="${root}pages/core/role-select.html" class="btn btn-primary" style="padding: 0.5rem 1rem; font-size: 0.9rem;">Sign Up</a>
        `;
        if (user) authSection = `
                <a href="${root}pages/features/dashboard.html" class="nav-link" style="margin-right: 1rem; font-weight: 700; color: var(--clr-primary);">Hi, ${user.name}</a>
                <button id="logoutBtn" class="btn btn-outline" style="padding: 0.5rem 1rem; font-size: 0.9rem;">Log Out</button>
            `;
        this.innerHTML = `
            <nav class="nav-bar">
                <a href="${root}index.html" class="nav-brand">
                    <div style="width: 32px; height: 32px; background: var(--clr-primary); border-radius: 8px; display: flex; align-items: center; justify-content: center; color: white;">E</div>
                    <span>EnglishO</span>
                </a>
                <div class="nav-links">
                    <a href="${root}index.html" class="nav-link">Home</a>
                    <a href="${root}pages/info/service.html" class="nav-link">Platform</a>
                    <a href="${root}pages/info/about.html" class="nav-link">Methodology</a>
                    <a href="${root}pages/info/contact.html" class="nav-link">Contact</a>
                </div>
                <div>
                    ${authSection}
                </div>
            </nav>
        `;
        const logoutBtn = this.querySelector('#logoutBtn');
        if (logoutBtn) logoutBtn.addEventListener('click', ()=>{
            (0, $9su8u.SessionManager).logoutUser();
        });
    }
}
customElements.define('englisho-navbar', $1118bd67751aa98c$var$Navbar);


//# sourceMappingURL=repo.e5d2eb96.js.map
